export const getIniciaisPrimeiroUltimoNome = (nomeCompleto?: string): string => {
  if (!nomeCompleto) return ''
  const nomeArray = nomeCompleto.trim().split(' ')
  const iniciaisArray = nomeArray.map((val, index) => {
    if (index === 0 || index === nomeArray.length - 1) {
      return val.substring(0, 1)
    }
    return null
  })
  return iniciaisArray.join('').toUpperCase()
}

export const getPrimeiroUltimoNome = (nomeCompleto: string | null): string => {
  if (!nomeCompleto?.trim()) {
    throw new Error('Nome inválido')
  }
  const names = nomeCompleto.trim().split(/\s+/)
  return names.length > 1 ? `${names[0]} ${names[names.length - 1]}` : `${names[0]}`
}

export class StringUtils {
  static singularPlural(number: number, singularWord: string, pluralWord: string) {
    return number === 1 ? singularWord : pluralWord
  }

  static normalize(str: string) {
    return str.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
  }

  static capitalize(str: string) {
    return str
      .toLowerCase()
      .split(' ')
      .map((palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(' ')
  }

  static removeAcentos(str: string) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  static readonly removeSpecialCharacters = (value: string): string => value?.replace(/\D/g, '')
}
